import { IcomoonReact } from "./IcomoonReact/IcomoonReact";

export { iconList } from "./IcomoonReact/IcomoonReact";
export default IcomoonReact;
